// Function to dynamically add the HubSpot script and set data-src attribute
export const loadHubSpotScript = () => {
  // Remove existing script if any
  const existingScript = document.getElementById('hubspot-meetings-script');
  if (existingScript) {
    existingScript.remove();
  }

  // Create a new script element
  const script = document.createElement('script');
  script.id = 'hubspot-meetings-script';
  script.type = 'text/javascript';
  script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';

  // Append the script to the body
  document.body.appendChild(script);
};

export const handleEmployeeSizeChange = (size) => {
  const iframeContainer = document.querySelector('.meetings-iframe-container');
  let dataSrc;

  // Determine data-src based on employee size
  switch (size) {
    case 'Under 5':
      dataSrc = 'https://meetings.hubspot.com/somit/scheduling-page-under-5?embed=true';
      break;
    case '6 to 25':
      dataSrc = 'https://meetings.hubspot.com/somit/scheduling-page-6-to-25?embed=true';
      break;
    case '26 to 50':
      dataSrc = 'https://meetings.hubspot.com/somit/scheduling-page-26-to-50?embed=true';
      break;
    case '51 to 100':
      dataSrc = 'https://meetings.hubspot.com/somit/scheduling-page-51-to-100?embed=true';
      break;
    default:
      dataSrc = 'https://meetings.hubspot.com/somit/scheduling-page-101-and-above?embed=true';
  }

  iframeContainer.setAttribute('data-src', dataSrc);

  // Load the HubSpot script
  loadHubSpotScript();
};

// Function to show Mariam's calender for 4 accounting pages
export const showParternshipTeamCalendar = () => {
  const iframeContainer = document.querySelector('.meetings-iframe-container');
  const dataSrc = 'https://meetings.hubspot.com/somit/partner-referral-meeting?embed=true';

  iframeContainer.setAttribute('data-src', dataSrc);

  // Load the HubSpot script
  loadHubSpotScript();
};